<div class="popup-convert-proposal">
  <!-- Header -->
  <div class="row m-auto popup-header-new align-items-center">
    <div class="col-md-9 align-items-center">
      <h4>{{ isEditMode ? 'Edit Milestone' : 'Add Milestone' }}</h4>
    </div>

    <div class="col-md-3 text-right align-items-center">
      <span class="cp close-icon" mat-dialog-close (click)="close()">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32">
          <g id="Group_5952" data-name="Group 5952" transform="translate(-0.001)">
            <rect id="Rectangle_865" data-name="Rectangle 865" width="34" height="32" rx="1" transform="translate(0.001)" fill="#f82825"/>
            <path id="Path_10" data-name="Path 10" d="M12.146,6.246a.685.685,0,0,1-.72.46c-1.52-.007-3.04,0-4.56,0-.162,0-.162,0-.162.163,0,1.52,0,3.04,0,4.56a.685.685,0,0,1-.46.72H5.914a.685.685,0,0,1-.46-.72c.007-1.52,0-3.04,0-4.56,0-.163,0-.164-.161-.164H.665a.632.632,0,0,1-.624-.4.622.622,0,0,1,.576-.842c.347-.005.695,0,1.042,0H5.295c.162,0,.163,0,.163-.162q0-2.321,0-4.643a.629.629,0,0,1,.4-.612A.622.622,0,0,1,6.7.618c.005.355,0,.711,0,1.066q0,1.806,0,3.612c0,.161,0,.161.164.161,1.52,0,3.04,0,4.56,0a.684.684,0,0,1,.72.46Z" transform="translate(8.612 16.2) rotate(-45)" fill="#f1f1f1" stroke="#f1f1f1" stroke-width="1.5"/>
          </g>
        </svg>
      </span>
    </div>
  </div>

  <!-- Body -->
  <div class="row m-auto popup-body popup-convert-wrapper popup-revision-wrrapper popup-sent-wrapper align-items-center">

    <form [formGroup]="milestoneForm" style="width: 100%;">
      <!-- Milestone Name Field -->
      <div class="form-row">
        <div class="form-group col-12">
          <label for="name" class="custom_label">Milestone Name *</label>
          <input matInput
            type="text"
            id="name"
            formControlName="milestone_name"
            class="form-control"
            placeholder="Enter milestone name"
            name="milestone_name"
            maxlength="255"
            autocomplete="off">
          @if (submitted && f['milestone_name'].errors?.['required']) {
            <div class="error-text mt-1">
              Milestone name is required
            </div>
          }
          @if (submitted && f['milestone_name'].errors?.['maxlength']) {
            <div class="error-text mt-1">
              Name cannot exceed 255 characters
            </div>
          }
        </div>
      </div>

      <!-- Due Date Field - Date Picker -->
      <div class="form-row">
        <div class="form-group col-12">
          <label for="due_date" class="custom_label">Due Date *</label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput
              [matDatepicker]="picker"
              formControlName="due_date"
              placeholder="Select due date"
              readonly>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          @if (submitted && f['due_date'].errors?.['required']) {
            <div class="error-text mt-1">
              Due date is required
            </div>
          }
          @if (dueDateError) {
            <div class="error-text mt-1">
              {{ dueDateError }}
            </div>
          }
        </div>
      </div>

      <!-- Assign To User Field -->
      <div class="form-row">
        <div class="form-group col-12">
          <label for="assigned_id" class="custom_label">Assign To *</label>
          <ng-select
            id="assigned_id"
            [items]="staffs"
            placeholder="Select User"
            [closeOnSelect]="true"
            formControlName="assigned_id"
            bindLabel="full_name"
            >
          </ng-select>
          @if (submitted && f['assigned_id'].errors?.['required']) {
            <div class="error-text mt-1">
              Please select a user to assign to
            </div>
          }
        </div>
      </div>
    </form>

    <!-- Action Buttons -->
    <div class="row mt-5">
      <div class="col-md-6">
        <button class="btn btn-cancel" (click)="close()">Cancel</button>
      </div>
      <div class="col-md-6">
        <button class="btn btn-convert" (click)="onSubmit()" [disabled]="isLoading">
          @if (isLoading) {
            <mat-spinner diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
          }
          <span>{{ isEditMode ? 'Update Milestone' : 'Create Milestone' }}</span>
        </button>
      </div>
    </div>

  </div>
</div>